import * as yup from 'yup';

export const smartphoneSchema = yup.object().shape({
  smartphone: yup.string().optional(),
  available: yup.string().optional(),
});
